module.exports = __webpack_public_path__ + "img/img-advisoryboard1@1x.94fec07b.jpg";